

type multiLineComponentProps = {
    text:string,
    uniqueKey:string
}

const MultiLineComponent = (props:multiLineComponentProps) => {
  
    return(
        <div key={`${props.uniqueKey}`}>
            {props.text.split("\n").map((line, index) => <div key={`${props.uniqueKey}_${index}`}>{line}</div>)}
        </div>
    );
}

export default MultiLineComponent;